import { v4 } from "uuid";

export function createUUID() {
  return v4();
}
